// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__pczXe","faq__title":"faq_faq__title__sClB7","faq__list":"faq_faq__list__K2TPa"};